import { defineMessages } from 'react-intl.macro';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from '@tmapy/redux';

import { ErrorPage } from '@tmapy/style-guide';

import { useAuth } from '../../hooks';
import { LogoutBtn } from '../../auth/components/LogoutBtn';

import { RelatedApps } from './RelatedApps';

export const ERROR_TYPE = {
  ERROR: 'ERROR',
  NOT_FOUND: 'NOT_FOUND',
  PERMISSION_DENIED: 'PERMISSION_DENIED',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ERROR_TYPE = keyof typeof ERROR_TYPE;

type ErrorProps = {
  type: ERROR_TYPE;
};

const titleMessages = defineMessages<ERROR_TYPE>({
  [ERROR_TYPE.ERROR]: {
    id: 'error.title.error',
    defaultMessage: 'Ajaj!',
  },
  [ERROR_TYPE.NOT_FOUND]: {
    id: 'error.title.notFound',
    defaultMessage: 'Jejda!',
  },
  [ERROR_TYPE.PERMISSION_DENIED]: {
    id: 'error.title.permissionDenied',
    defaultMessage: 'Ouvej!',
  },
});

const descriptionMessages = defineMessages<ERROR_TYPE>({
  [ERROR_TYPE.ERROR]: {
    id: 'error.description.error',
    defaultMessage: 'Něco se nepovedlo.',
  },
  [ERROR_TYPE.NOT_FOUND]: {
    id: 'error.description.notFound',
    defaultMessage: 'Požadovaná stránka neexistuje :(',
  },
  [ERROR_TYPE.PERMISSION_DENIED]: {
    id: 'error.description.permissionDenied',
    defaultMessage: 'Přístup odepřen.',
  },
});

const relatedAppsMessages = defineMessages<ERROR_TYPE>({
  [ERROR_TYPE.ERROR]: {
    id: 'error.relatedApps.error',
    defaultMessage: 'Zkusit znovu',
  },
  [ERROR_TYPE.NOT_FOUND]: {
    id: 'error.relatedApps.notFound',
    defaultMessage: 'Přejít do aplikace',
  },
  [ERROR_TYPE.PERMISSION_DENIED]: {
    id: 'error.relatedApps.permissionDenied',
    defaultMessage: 'Přejít do aplikace',
  },
});

export const Error: React.FC<ErrorProps> = ({ type }) => {
  const config = useSelector((state) => state.app.config);

  const allowedApps = config.apps ? Object.entries(config.apps) : null;

  return (
    <ErrorPage
      title={<FormattedMessage {...titleMessages[type]} />}
      subtitle={<FormattedMessage {...descriptionMessages[type]} />}
    >
      {allowedApps && allowedApps.length > 0 && (
        <div className='sg-a-mt-4'>
          <p className='sg-u-type-sml'>
            <FormattedMessage {...relatedAppsMessages[type]} />
          </p>
          <div className='sg-a-mt-2'>
            <RelatedApps allowedApps={allowedApps} />
          </div>
        </div>
      )}
      <div className='sg-a-mt-2'>
        <LogoutBtn />
      </div>
    </ErrorPage>
  );
};
